export default __webpack_public_path__ + "static/media/Axiforma-Light.fe89ffb1.ttf";